import React, { memo } from "react";
import AerosNode from "./AerosNode";

export default memo(({ data, id, isConnectable, selected }) => (
  <AerosNode id={id} type="switchFlow" selected={selected} isConnectable={isConnectable}>
    {data?.flowSelected?.name}
  </AerosNode>
));
